export default {
  title_one: 'Usunąć {{count}} modyfikatory?',
  title_few: 'Usunąć {{count}} modyfikatory?',
  title_many: 'Usunąć {{count}} modyfikatorów?',
  title_other: 'Usunąć {{count}} modyfikatory?',
  description: '<strong>{{items}}</strong> zostanie usunięte z menu',
  buttons: {
    yes: 'Tak',
    no: 'Nie',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Nie udało się usunąć modyfikatora',
    failed_to_delete_modifier_few: 'Nie udało się usunąć modyfikatorów',
    failed_to_delete_modifier_many: 'Nie udało się usunąć modyfikatorów',
    failed_to_delete_modifier_other: 'Nie udało się usunąć modyfikatorów',
    modifiers_got_deleted_one: 'Modyfikator został usunięty',
    modifiers_got_deleted_few: 'Modyfikatory zostały usunięte',
    modifiers_got_deleted_many: 'Modyfikatory zostały usunięte',
    modifiers_got_deleted_other: 'Modyfikatory zostały usunięte',
  },
};
